import { formatNumber } from 'utils/utils';
import { ButtonLink } from './ButtonLink';
import { useEffect, useState } from 'react';

export function BasketContentFooter(props) {
    const { shoppingBag: { subTotalPrice, totalPrice } } = props;
    const [deliveryPrice, setDeliveryPrice] = useState(0)

    useEffect(() => {
        fetchDeliveryPrice()
    })

    const fetchDeliveryPrice = async () => {
        const response = await fetch('/api/orders/delivery-cost')
        const data = await response.json()
        setDeliveryPrice(data)
    }

    return (
        <>
            <div className="body-text6 ptb-20">
                <div className="row mb-8">
                    <div className="col">Subtotal</div>
                    <div className="col-auto body-text7">£{formatNumber(totalPrice)}</div>
                </div>
                <div className="row">
                    <div className="col"><div className='sm-max-width-230'>Delivery (United Kingdom. Change in Checkout)</div></div>
                    <div className="col-auto body-text7">{deliveryPrice > 0 ? "£" + formatNumber(deliveryPrice) : "Free"}</div>
                </div>
            </div>
            <div className="dashed-line"></div>
            <div className="mtb-24">
                <span className="subtitle2 uppercase">Total:</span> <span className="body-text1">£{formatNumber(totalPrice + deliveryPrice)}</span>
            </div>
            <div>
                <ButtonLink name="Continue to checkout" url="/Checkout" />
            </div>
        </>
    );
}